import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { ButtonBase } from '@material-ui/core';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import clickHemofiliaLogo from '~/assets/clickhemofilia-logo-registered.png';
import Menu from './components/MenuDropDown';
import Informations from './components/Informations';

import { Container } from './styles';

export default function Header() {
  const [anchorEl, setAnchorEl] = useState(null);
  const profile = useSelector((state) => state.user.profile);
  const history = useHistory();
  const { hemocenter } = profile;

  return (
    <Container>
      <AppBar position="fixed" variant="outlined">
        <Toolbar>
          <ButtonBase onClick={() => history.push('/search')}>
            <img id="clickhemofilia-logo" src={clickHemofiliaLogo} alt="clickhemofilia-logo" />
          </ButtonBase>

          <Typography noWrap className="title">
            UNIDADE DE SAÚDE {hemocenter && hemocenter.alias}
          </Typography>

          <Informations setAnchorEl={setAnchorEl} />

          <Menu anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
        </Toolbar>
      </AppBar>
    </Container>
  );
}
